<ndt-user-register
   [filters]="filters"
   [showCreate]="false"
   [showAllUsersControl]="true"
   [route]="systemRouterLink"
></ndt-user-register>
